import { render } from "./view-billings.vue?vue&type=template&id=75a7dfe9&scoped=true"
import script from "./view-billings.vue?vue&type=script&lang=js"
export * from "./view-billings.vue?vue&type=script&lang=js"

import "./view-billings.vue?vue&type=style&index=0&id=75a7dfe9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a7dfe9"]])

export default __exports__